import {PageWrapper} from "../components/common/PageWrapper";
import Tabs from "../components/Tabs";
import {useState} from "react";
import Offers from "../components/bedirect/Offers";
import MailMarketing from "../components/bedirect/MailMarketing";
import Settings from "../components/bedirect/Settings";
import CompetitiveSet from "../components/bedirect/CompetitiveSet";

export default function BeDirectPage() {

    const [currentTab, setCurrentTab] = useState<string>('offers');

    return (
        <PageWrapper centered maxWidth={'1000px'}>
            <div className="flex items-center space-x-12">
                <div>
                    <img className={'w-40'} src="/analytics.png" alt="BeSafe Direct Analytics"/>
                </div>

                <div>
                    <div className="font-bold mb-2 text-4xl text-slate-800">
                        BeDirect
                    </div>
                    <div className="text-xl text-slate-500">
                        incrementa la conversione del tuo canale diretto e analizza la tua struttura
                    </div>
                </div>
            </div>

            <div className="mt-10">
                <Tabs
                    onTabSelected={setCurrentTab}
                    currentTab={currentTab}
                    tabs={[
                        { name: 'AI Competitor Report', key: 'pricechecker' },
                        { name: 'Offerte', key: 'offers' },
                        // { name: 'Mail marketing', key: 'mailmarketing' }
                    ]}
                />
            </div>

            { currentTab === 'offers' && <Offers /> }
            { currentTab === 'mailmarketing' && <MailMarketing /> }
            { currentTab === 'pricechecker' && <CompetitiveSet /> }
            { currentTab === 'settings' && <Settings /> }
        </PageWrapper>
    )

}
